export default __webpack_public_path__ + "static/gg-regular-ef65ef2e8c36a581458fa40117972d08.woff2";